import http from '../../http/common'

const resource = '/documents'

export default {

	get: (payload) => http.get(`${resource}${payload}`),
	delete: (payload) => http.post(`${resource}/delete-docs`, payload),
}
